import React, {useState, useEffect} from 'react';
import {useTranslation} from "react-i18next";

const ViewOrder = ({dataValid, uploadedData, totalCardholders, totalAmountLoaded, validationErrors}) => {

    const { t } = useTranslation();

    return (
        <div className="step">
            View Order
        </div>
    );
};

export default ViewOrder;
